export enum DATA_FORMAT {
    NUMBER = 'NUMBER',
    MINUTE = 'MINUTE',
    HOUR = 'HOUR'
}
